import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/imports/')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('orders:write')) {
      throw redirect({ to: '/' });
    }
  },
  // The `feat-file-import` guard lives in useImportPage() (component) rather than here:
  // useIsFeatureFlagActive is fail-closed while useFeatureFlags() is loading, and beforeLoad has
  // no hook access to wait for that query to settle — redirecting on the boolean alone here would
  // bounce a direct page load to /orders before the flags arrive.
  component: lazyRouteComponent(() => import('&/features/imports/pages/import-page')),
});
